import { Component, Input } from '@angular/core';
import { ProductGroup } from 'src/app/order/models/product-group.model';

@Component({
    selector: 'app-product-group-form',
    templateUrl: './product-group-form.component.html',
    styleUrls: ['./product-group-form.component.scss'],
    standalone: false
})
export class ProductGroupFormComponent {

  @Input()
  productGroup: ProductGroup;
}
